/**
 * More about me main menu
 */
export const MaMMenu = (function () {
  var init = function () {
    $(".mam-menu-toggle").on("click", function () {
      $(".mam-items-row").slideToggle();
    });
    $(".expand-sub-menu").on("click", function () {
      $(this).closest(".mam-main-menu").find(".sub-link").slideToggle();
    });
  };

  return {
    init: init,
  };
})();
